import { Box } from '@mui/material';
import { SectionHeaderCellProps } from '../../types';

const PendingSectionCell = ({ _customRowProps }: SectionHeaderCellProps) => {
  return <Box position={'relative'}>Pending</Box>;
};

export default PendingSectionCell;
